










































import Vue from 'vue';
import { IShoppingCartIndividual } from '@/common/interfaces/cart.interface';
import { ILimitingObject } from '@/common/interfaces/limiting.interface';
import { IProduct } from '@/common/interfaces/products.interface';
import AddToCart from '../common/addtocart/AddToCart.vue';
import ProductListPriceDisplay from './ProductListPriceDisplay.vue';
import ProductHelper from '@/helpers/ProductHelper';

export default Vue.extend({
  name: `ProductListAddToCart`,
  components: { AddToCart, ProductListPriceDisplay },
  data(): { ProductHelper: typeof ProductHelper} {
    return {
      ProductHelper,
    };
  },
  props: {
    addToCartButtonDisplayMode: {
      default: `simple-button`,
      type: String,
    },
    availableCarts: {
      required: true,
      type: Array as () => IShoppingCartIndividual[],
    },
    discountActive: {
      required: true,
      type: Boolean,
    },
    hasMultipleCarts: {
      required: true,
      type: Boolean,
    },
    isPartner: {
      required: true,
      type: Boolean,
    },
    limiting: {
      required: true,
      type: Object as () => ILimitingObject,
    },
    loading: {
      required: true,
      type: Boolean,
    },
    mode: {
      required: true,
      type: String,
    },
    product: {
      required: true,
      type: Object as () => IProduct,
    },
    selectedCartId: {
      required: true,
      validator: prop => Number.isInteger(prop) || prop === null,
    },
    showQuantitySelect: {
      default: false,
      type: Boolean,
    },
  },
});
